import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import { getProdutoReduzido } from '../../store/actions/produto';
import HeaderWebPage from '../businessLandingPage/HeaderWebPage';

const APPLE_APP_ID = '6758161244';
const ANDROID_PACKAGE = 'com.mobile.passarela44';
const BRAND_NAME = 'Passarela 44';
const IOS_APP_SCHEME = 'passarela44';

const PRODUCT_HEADER_MENU_ITEMS = [
    { label: 'Home', href: '/' },
    { label: 'Baixar App', href: '#baixar-app' },
    { label: 'Area do Lojista', href: '/lojista', className: 'btn-lojista' },
];

// ---- Formatador de preço seguro ----
function formatarPreco(valor) {
    const num = Number(valor);
    if (!Number.isFinite(num)) return '0,00';
    return num.toFixed(2).replace('.', ',');
}

const ProductLanding = props => {
    const { id } = useParams();
    const [erro, setErro] = useState(null);
    const [platform, setPlatform] = useState('desktop');
    const [autoOpenStatus, setAutoOpenStatus] = useState('idle');
    const { getProdutoReduzido, produto, loading } = props;

    // Detecta plataforma do usuário
    useEffect(() => {
        const ua = navigator.userAgent || '';
        if (/iPhone|iPad|iPod/i.test(ua)) {
            setPlatform('ios');
        } else if (/Android/i.test(ua)) {
            setPlatform('android');
        } else {
            setPlatform('desktop');
        }
    }, []);

    // Busca o produto na API
    useEffect(() => {
        if (!id) {
            setErro('Produto não encontrado');
            return;
        }

        setErro(null);
        getProdutoReduzido(id);
    }, [id, getProdutoReduzido]);

    // URLs úteis
    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://app.passarela44.com.br';
    const productUrl = `${origin}/produto/${id}`;
    const appStoreUrl = `https://apps.apple.com/br/app/passarela-44/id${APPLE_APP_ID}`;
    const playStoreUrl = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
    const iosSchemeUrl = `${IOS_APP_SCHEME}://produto/${id}`;

    // intent:// URL do Android: abre o app se instalado, cai na Play Store se não
    const androidIntentUrl =
        `intent://app.passarela44.com.br/produto/${id}` +
        `#Intent;scheme=https;package=${ANDROID_PACKAGE};` +
        `S.browser_fallback_url=${encodeURIComponent(playStoreUrl)};end`;

    // Tenta abrir o app automaticamente em dispositivos móveis.
    useEffect(() => {
        if (!id || platform === 'desktop' || autoOpenStatus !== 'idle') {
            return;
        }

        setAutoOpenStatus('trying');
        let finished = false;

        const markOpened = () => {
            if (!finished) {
                finished = true;
                setAutoOpenStatus('opened');
            }
        };

        const onVisibilityChange = () => {
            if (document.hidden) {
                markOpened();
            }
        };

        document.addEventListener('visibilitychange', onVisibilityChange);

        const fallbackTimer = window.setTimeout(() => {
            if (finished || document.hidden) {
                return;
            }

            setAutoOpenStatus('failed');
        }, 1600);

        if (platform === 'android') {
            window.location.href = androidIntentUrl;
        }

        if (platform === 'ios') {
            window.location.href = iosSchemeUrl;
        }

        return () => {
            window.clearTimeout(fallbackTimer);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [id, platform, autoOpenStatus, androidIntentUrl, iosSchemeUrl]);

    const produtoId = produto && (produto.id || produto.idProduto);
    const hasProdutoData =
        produto &&
        Object.keys(produto).length > 0 &&
        (!produtoId || String(produtoId) === String(id));
    const imageUrl = produto && typeof produto.imagemPrincipal === 'string' ? produto.imagemPrincipal : '';

    // URL de compartilhamento no WhatsApp
    const whatsappShareUrl = hasProdutoData
        ? `https://api.whatsapp.com/send?text=${encodeURIComponent(
            `${produto.nome} — R$ ${formatarPreco(produto.precoPraticadoVarejo)} ${productUrl}`
        )}`
        : '#';

    // ---- Renderização condicional ----

    if (loading) {
        return (
            <div style={styles.container} className='product-landing-root'>
                <style>{landingAnimationsCss}</style>
                <HeaderWebPage
                    menuItems={PRODUCT_HEADER_MENU_ITEMS}
                    headerBgColor='#E2725B'
                />
                <div style={styles.content} className='pl-content'>
                    <p style={styles.loading}>Carregando produto...</p>
                </div>
            </div>
        );
    }

    if (erro || (!loading && !hasProdutoData)) {
        return (
            <div style={styles.container} className='product-landing-root'>
                <style>{landingAnimationsCss}</style>
                <HeaderWebPage
                    menuItems={PRODUCT_HEADER_MENU_ITEMS}
                    headerBgColor='#E2725B'
                />
                <div style={styles.content} className='pl-content'>
                    <section style={styles.headerCompact}>
                        <h2 style={styles.brand}>{BRAND_NAME}</h2>
                    </section>
                    <h1 style={styles.title}>Produto não encontrado</h1>
                    <p style={styles.description}>
                        Esse produto pode ter sido removido ou o link está incorreto.
                    </p>
                    <a href='/' style={styles.textLink} className='pl-link-button'>
                        ← Voltar para a página inicial
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container} className='product-landing-root'>
            <style>{landingAnimationsCss}</style>
            <HeaderWebPage
                menuItems={PRODUCT_HEADER_MENU_ITEMS}
                headerBgColor='#E2725B'
            />
            <div style={styles.content} className='pl-content'>
                <div
                    style={styles.card}
                    className={`pl-card pl-fade-in ${imageUrl ? '' : 'pl-card-no-image'}`}
                >
                    {imageUrl && (
                        <div className='pl-image-wrap'>
                            <img
                                src={imageUrl}
                                alt={produto.nome || 'Produto Passarela 44'}
                                style={styles.image}
                            />
                        </div>
                    )}

                    <div className='pl-details'>
                        <h1 style={styles.title}>{produto.nome}</h1>
                        <p style={styles.price}>
                            R$ {formatarPreco(produto.precoPraticadoVarejo)}
                        </p>

                        {produto.descricao && (
                            <p style={styles.description}>{produto.descricao}</p>
                        )}

                        <div style={styles.ctaBlock} id='baixar-app'>
                            <p style={styles.ctaLabel}>
                                {platform !== 'desktop' && autoOpenStatus === 'trying'
                                    ? 'Abrindo o aplicativo...'
                                    : 'Abrir no aplicativo'}
                            </p>

                            {platform !== 'desktop' && autoOpenStatus === 'failed' && (
                                <p style={styles.ctaHint}>Nao foi possivel abrir automaticamente. Tente pelos botoes abaixo.</p>
                            )}

                            {platform === 'ios' && (
                                <>
                                    <a href={iosSchemeUrl} style={styles.primaryButton} className='pl-button pl-button-primary'>
                                        Abrir no app
                                    </a>
                                    <a
                                        href={appStoreUrl}
                                        style={styles.secondaryButton}
                                        className='pl-button pl-button-secondary'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        Baixar na App Store
                                    </a>
                                </>
                            )}

                            {platform === 'android' && (
                                <>
                                    <a href={androidIntentUrl} style={styles.primaryButton} className='pl-button pl-button-primary'>
                                        Abrir no app
                                    </a>
                                    <a
                                        href={playStoreUrl}
                                        style={styles.secondaryButton}
                                        className='pl-button pl-button-secondary'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        Baixar na Google Play
                                    </a>
                                </>
                            )}

                            {platform === 'desktop' && (
                                <>
                                    <a
                                        href={appStoreUrl}
                                        style={styles.secondaryButton}
                                        className='pl-button pl-button-secondary'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        Baixar na App Store
                                    </a>
                                    <a
                                        href={playStoreUrl}
                                        style={styles.secondaryButton}
                                        className='pl-button pl-button-secondary'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        Baixar na Google Play
                                    </a>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <footer style={styles.footer}>
                    <p style={styles.footerText}>Compartilhe este produto:</p>
                    <a
                        href={whatsappShareUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        style={styles.whatsappButton}
                        className='pl-button pl-button-whatsapp'
                    >
                        Enviar no WhatsApp
                    </a>
                </footer>
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    produto: state.produto.produto,
    loading: state.produto.loading,
})
const mapDispatchToProps = dispatch => bindActionCreators({
    getProdutoReduzido,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProductLanding)

const landingAnimationsCss = `
    .product-landing-root .pl-fade-in {
        animation: pl-fade-up 260ms ease-out;
    }

    .product-landing-root .pl-card {
        transition: box-shadow 180ms ease, transform 180ms ease;
    }

    .product-landing-root .pl-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 28px rgba(53, 108, 124, 0.16);
    }

    .product-landing-root .pl-content {
        width: 100%;
        max-width: 1100px;
        margin: 0 auto;
        padding: 84px 16px 32px;
        box-sizing: border-box;
    }

    .product-landing-root .pl-image-wrap {
        width: 100%;
        min-width: 0;
    }

    .product-landing-root .pl-details {
        width: 100%;
        min-width: 0;
    }

    .product-landing-root .pl-card-no-image .pl-details {
        grid-column: 1 / -1;
    }

    .product-landing-root .pl-button,
    .product-landing-root .pl-link-button {
        transition: transform 160ms ease, filter 160ms ease, box-shadow 160ms ease;
    }

    .product-landing-root .pl-button:hover,
    .product-landing-root .pl-link-button:hover {
        transform: translateY(-1px);
        filter: brightness(0.97);
    }

    .product-landing-root .pl-button:focus-visible,
    .product-landing-root .pl-link-button:focus-visible {
        outline: 3px solid rgba(53, 108, 124, 0.35);
        outline-offset: 2px;
        box-shadow: 0 0 0 4px rgba(226, 114, 91, 0.22);
    }

    .product-landing-root .pl-button-primary:hover {
        filter: brightness(0.94);
    }

    .product-landing-root .pl-button-secondary:hover {
        filter: brightness(1.06);
    }

    .product-landing-root .pl-button-whatsapp:hover {
        filter: brightness(0.95);
    }

    @keyframes pl-fade-up {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .product-landing-root .pl-fade-in,
        .product-landing-root .pl-card,
        .product-landing-root .pl-button,
        .product-landing-root .pl-link-button {
            animation: none !important;
            transition: none !important;
        }
    }

    @media (min-width: 860px) {
        .product-landing-root .pl-card {
            display: grid;
            grid-template-columns: minmax(280px, 420px) minmax(0, 1fr);
            gap: 24px;
            padding: 24px;
        }

        .product-landing-root .pl-image-wrap img {
            height: 100%;
            max-height: 560px;
            min-height: 280px;
        }
    }

    @media (max-width: 640px) {
        .product-landing-root .pl-content {
            padding: 84px 12px 20px;
        }
    }
`;

// ---- Estilos ----
const styles = {
    container: {
        width: '100%',
        margin: 0,
        fontFamily: 'Poppins, Roboto, Arial, sans-serif',
        color: '#333333',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #FFFFFF 0%, #F4ECE4 100%)',
    },
    content: {
        width: '100%',
    },
    header: {
        position: 'relative',
        top: 'auto',
        width: 'auto',
        zIndex: 'auto',
        boxShadow: 'none',
        borderBottom: '1px solid #F0DDD1',
        padding: '12px 0',
        marginBottom: 20,
    },
    headerCompact: {
        position: 'relative',
        top: 'auto',
        width: 'auto',
        zIndex: 'auto',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderBottom: '1px solid #F0DDD1',
        paddingBottom: 12,
        marginBottom: 20,
    },
    brand: {
        fontSize: 28,
        color: '#356C7C',
        margin: 0,
    },
    headerSubtitle: {
        margin: '8px 0 0',
        color: '#4B5960',
        fontSize: 14,
    },
    card: {
        background: '#FFFFFF',
        borderRadius: 14,
        padding: 16,
        boxShadow: '0 8px 24px rgba(53, 108, 124, 0.12)',
    },
    image: {
        width: '100%',
        borderRadius: 12,
        marginBottom: 0,
        display: 'block',
        objectFit: 'cover',
    },
    title: {
        fontSize: 24,
        margin: '8px 0',
        lineHeight: 1.3,
        color: '#333333',
    },
    price: {
        fontSize: 28,
        fontWeight: 'bold',
        color: '#356C7C',
        margin: '8px 0 16px',
    },
    description: {
        fontSize: 15,
        lineHeight: 1.5,
        color: '#555',
        marginBottom: 24,
    },
    ctaBlock: {
        background: '#F4ECE4',
        padding: 20,
        borderRadius: 12,
        textAlign: 'center',
        marginTop: 24,
    },
    ctaLabel: {
        fontSize: 16,
        marginBottom: 16,
        color: '#356C7C',
        fontWeight: 600,
    },
    ctaHint: {
        fontSize: 13,
        margin: '0 0 12px',
        color: '#4B5960',
    },
    primaryButton: {
        display: 'block',
        background: '#E2725B',
        color: '#fff',
        padding: '14px 20px',
        borderRadius: 8,
        textDecoration: 'none',
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 8,
    },
    secondaryButton: {
        display: 'block',
        background: '#356C7C',
        color: '#fff',
        padding: '14px 20px',
        borderRadius: 8,
        textDecoration: 'none',
        fontSize: 16,
        marginBottom: 8,
    },
    textLink: {
        display: 'inline-block',
        color: '#356C7C',
        marginTop: 12,
        textDecoration: 'none',
        fontWeight: 500,
    },
    loading: {
        textAlign: 'center',
        padding: 40,
        marginTop: 24,
        color: '#666',
    },
    footer: {
        marginTop: 32,
        paddingTop: 20,
        borderTop: '1px solid #eee',
        textAlign: 'center',
        fontSize: 14,
        color: '#666',
    },
    footerText: {
        marginBottom: 8,
        color: '#fff',
    },
    whatsappButton: {
        display: 'inline-block',
        background: '#25D366',
        color: '#fff',
        padding: '10px 16px',
        borderRadius: 6,
        textDecoration: 'none',
        marginTop: 8,
    },
};